export default "__VITE_ASSET__790398c2__"